import Checkbox from './CheckBox';
import CheckboxGroup from './CheckBoxGroup';
import CheckboxButton from './CheckBoxButton';

Checkbox.Group = CheckboxGroup;
Checkbox.Button = CheckboxButton;

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/checkbox/index.js
// module id = 36
// module chunks = 0